import { render, staticRenderFns } from "./KorisnikDetails.vue?vue&type=template&id=0ab7d569&scoped=true&"
import script from "./KorisnikDetails.vue?vue&type=script&lang=js&"
export * from "./KorisnikDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7d569",
  null
  
)

export default component.exports